import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, BriefcaseIcon, MessagesSquareIcon, ListChecksIcon, StarIcon, AwardIcon } from 'lucide-react';
import { Container } from '../ui/Container';
const modules = [{
  icon: AwardIcon,
  title: 'WA legal experience',
  body: 'Established Western Australian firm with a broad, senior legal team.'
}, {
  icon: MapPinIcon,
  title: 'Local Nedlands / Perth knowledge',
  body: 'Deep familiarity with WA courts, property and commercial context.'
}, {
  icon: BriefcaseIcon,
  title: 'Practical commercial advice',
  body: 'Legal thinking framed around your real business and personal goals.'
}, {
  icon: MessagesSquareIcon,
  title: 'Clear communication',
  body: 'Plain-English advice — no jargon without an explanation.'
}, {
  icon: ListChecksIcon,
  title: 'Options explained upfront',
  body: 'You understand your choices, likely outcomes and costs early.'
}];
export function TrustBar() {
  return <section id="trust" className="scroll-mt-24 bg-navy py-16 text-cream lg:py-20" data-id="element-210">
      <Container data-id="element-211">
        <div className="grid grid-cols-2 gap-8 border-b border-cream/10 pb-12 sm:grid-cols-3 lg:grid-cols-5" data-id="element-212">
          {modules.map((m, i) => {
          const Icon = m.icon;
          return <motion.div key={m.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i * 0.05
          }} data-id="element-213">
                <Icon className="h-6 w-6 text-brass-light" data-id="element-214" />
                <h3 className="mt-3 font-serif text-base leading-snug text-cream" data-id="element-215">
                  {m.title}
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-cream/60" data-id="element-216">
                  {m.body}
                </p>
              </motion.div>;
        })}
        </div>

        <div className="mt-10 grid grid-cols-1 items-center gap-6 lg:grid-cols-3" data-id="element-217">
          <blockquote className="lg:col-span-2" data-id="element-218">
            <div className="mb-2 flex gap-0.5 text-brass-light" data-id="element-219">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-220" />)}
            </div>
            <p className="font-serif text-xl leading-relaxed text-cream/90" data-id="element-221">
              “Clients come to Cullen Macleod when they need clear advice,
              steady guidance and practical legal solutions.”
            </p>
          </blockquote>
          <div className="rounded-xl border border-cream/10 bg-navy-800 p-5 text-sm text-cream/70" data-id="element-222">
            <p className="font-medium text-cream" data-id="element-223">Client feedback</p>
            <p className="mt-1.5 leading-relaxed" data-id="element-224">
              Verified testimonials and client references available on request.
              Placeholder — to be confirmed with the firm.
            </p>
          </div>
        </div>
      </Container>
    </section>;
}